import React from 'react';
import { AnimatePresence as FramerAnimatePresence, type AnimatePresenceProps } from 'framer-motion';

type SafeAnimatePresenceProps = React.PropsWithChildren<AnimatePresenceProps>;

/**
 * framer-motion's AnimatePresence is typed to possibly return undefined, which
 * React 18's JSX types reject; this wrapper normalises that to null.
 */
export const AnimatePresence: React.FC<SafeAnimatePresenceProps> = (props) => {
  const element = FramerAnimatePresence(props);
  return element ?? null;
};
